import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import { ScButtonEye } from '@/components/form/Password';
import { IconComponent } from '@/components/IconComponent';
import { maskCvvCredit } from '@/helpers/masks';
import { validateCvvCard } from '@/helpers/validators';
import { useToggle } from '@/hooks/common';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export const FieldCvvCard: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Cvv]
> = ({ fieldName, label, activeThemeMode }) => {
  const [showCvv, toggleShowCvv] = useToggle(false);

  return (
    <FormGroup mode={activeThemeMode} title={label || fieldName}>
      <Input
        autoComplete="off"
        formatter={maskCvvCredit}
        mode={activeThemeMode}
        name={fieldName}
        placeholder={label || fieldName}
        type={showCvv ? 'text' : 'password'}
        validate={validateCvvCard}
      />
      <ScButtonEye active={showCvv} onClick={toggleShowCvv} type="button">
        {showCvv ? (
          <IconComponent className="eye-icon" name="eyeOpenIcon" size="24px" />
        ) : (
          <IconComponent
            className="eye-icon"
            name="eyeClosedIcon"
            size="24px"
          />
        )}
      </ScButtonEye>
    </FormGroup>
  );
};
